import React from "react";
import { Button, Dialog, TextField } from "@material-ui/core";
import { Select } from "../../components";
import { useTranslation } from "localization/translation";

const EditOrderModal = ({
  open,
  form,
  statusOptions,
  modeOptions,
  onChange,
  onClose,
  onSave,
}) => {
  const translation = useTranslation();
  if (!form) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      classes={{ paper: "shadow-lg rounded" }}
    >
      <div className="p-4">
        <h4 className="font-weight-bold mb-3">
          {translation.edit_payment_order}
        </h4>
        <p className="text-black-50 mb-3">{form.public_id}</p>
        <Select
          label={translation.status}
          value={form.status || ""}
          field="name"
          options={statusOptions}
          onChange={(val) => onChange("status", val)}
        />
        <Select
          label={translation.confirmation_mode}
          value={form.confirmation_mode || ""}
          field="name"
          options={modeOptions}
          onChange={(val) => onChange("confirmation_mode", val)}
        />
        <Select
          label={translation.billing_period || translation.plan}
          value={form.billing_period || ""}
          field="name"
          options={[
            { id: "monthly", name: translation.monthly },
            { id: "annual", name: translation.annual },
          ]}
          onChange={(val) => onChange("billing_period", val)}
        />
        <TextField
          variant="outlined"
          className="my-2"
          fullWidth
          type="number"
          label={translation.amount}
          value={form.amount}
          onChange={(e) => onChange("amount", e.target.value)}
        />
        <TextField
          variant="outlined"
          className="my-2"
          fullWidth
          type="number"
          label={translation.discount_amount}
          value={form.discount_amount}
          onChange={(e) => onChange("discount_amount", e.target.value)}
        />
        <TextField
          variant="outlined"
          className="my-2"
          fullWidth
          type="number"
          label={translation.total_amount}
          value={form.total_amount}
          onChange={(e) => onChange("total_amount", e.target.value)}
        />
        <TextField
          variant="outlined"
          className="my-2"
          fullWidth
          label={translation.invoice}
          value={form.invoice_number}
          onChange={(e) => onChange("invoice_number", e.target.value)}
        />
        <TextField
          variant="outlined"
          className="my-2"
          fullWidth
          multiline
          rows={3}
          label={translation.description}
          value={form.description}
          onChange={(e) => onChange("description", e.target.value)}
        />
        <div className="pt-3 d-flex justify-content-end">
          <Button
            onClick={onClose}
            className="btn-neutral-secondary btn-pill mx-1"
          >
            {translation.cancel}
          </Button>
          <Button
            onClick={onSave}
            color="primary"
            variant="contained"
            className="btn-pill mx-1"
          >
            {translation.save}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default EditOrderModal;
